export default "__VITE_ASSET__De7XCJ2G__"